import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=016f8ac0"
import script from "./verification.vue?vue&type=script&lang=ts"
export * from "./verification.vue?vue&type=script&lang=ts"
import style0 from "./verification.vue?vue&type=style&index=0&id=016f8ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports